import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { auth } from '../firebase';
import API_URL from '../config';
import './TermsAcceptanceGate.css';

const UNGATED_PATHS = ['/login', '/terms', '/privacy', '/legal', '/join'];

const TermsAcceptanceGate = ({ children }) => {
  const { currentUser, userProfile, fetchUserProfile } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [agreed, setAgreed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Don't gate public routes or live-scoring
  const isUngated = UNGATED_PATHS.includes(location.pathname)
    || location.pathname.startsWith('/live-scoring/');

  // Only show gate for logged-in users with a profile that hasn't accepted terms
  const showGate = currentUser
    && userProfile
    && !userProfile.terms_accepted_at
    && !isUngated;

  const handleAccept = async () => {
    setLoading(true);
    setError('');
    try {
      const token = await auth.currentUser.getIdToken();
      const res = await fetch(`${API_URL}/auth/me`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ terms_accepted_at: new Date().toISOString() })
      });
      if (!res.ok) throw new Error('Failed to save. Please try again.');
      await fetchUserProfile(auth.currentUser);
    } catch (err) {
      setError(err.message);
    }
    setLoading(false);
  };

  return (
    <>
      {children}
      {showGate && (
        <div className="terms-gate-overlay">
          <div className="terms-gate-card">
            <h2>Terms & Conditions Update</h2>
            <p>
              We've added Terms & Conditions and a Privacy Policy. Please review and
              accept them to continue using 1-19 Golf.
            </p>

            <div className="terms-gate-links">
              <button type="button" onClick={() => navigate('/legal?tab=terms')}>
                Read Terms & Conditions
              </button>
              <button type="button" onClick={() => navigate('/legal?tab=privacy')}>
                Read Privacy Policy
              </button>
            </div>

            {error && <div className="terms-gate-error">{error}</div>}

            <label className="terms-gate-checkbox">
              <input
                type="checkbox"
                checked={agreed}
                onChange={(e) => setAgreed(e.target.checked)}
              />
              <span>
                I agree to the Terms & Conditions and Privacy Policy
              </span>
            </label>

            <button
              className="terms-gate-btn"
              disabled={!agreed || loading}
              onClick={handleAccept}
            >
              {loading ? 'Saving...' : 'Continue'}
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default TermsAcceptanceGate;
